/**
 * Comms-admin destinations for the ⌘K palette beyond the admin pages
 * themselves: each template and each verified sender, opening its detail
 * page. The admin pages are `settingsSearchKind` from `@ordo/agent-embed`,
 * which also owns the matcher these rank with. Pure — the fetching and the
 * palette wiring live in `agent-config.tsx`. Relative imports only, because
 * bun test does not resolve the client's path aliases.
 */

import { rankMatches } from '@ordo/agent-embed'

export interface AdminSearchHit {
  id: string
  title: string
  meta?: string
  href: string
}

/** One `GET /api/templates` row (inside `{ data }`), as far as search reads it. */
export interface TemplateSearchRow {
  id: string
  name: string
  slug: string
  subject: string | null
}

/** A template opens on its editor, so "invite" lands ready to edit. */
export function templateHits(query: string, templates: TemplateSearchRow[]): AdminSearchHit[] {
  return rankMatches(query, templates, (t) => ({ title: t.name, extra: `${t.slug} ${t.subject ?? ''}` })).map((t) => ({
    id: `template-${t.id}`,
    title: t.name,
    meta: t.slug,
    href: `/templates/${encodeURIComponent(t.id)}`,
  }))
}

/** One `GET /api/senders` row (inside `{ data }`), as far as search reads it. */
export interface SenderSearchRow {
  id: string
  nickname: string
  fromEmail?: string
  fromName?: string
  method?: 'EMAIL' | 'SMS'
  phoneNumber?: string
}

export function senderHits(query: string, senders: SenderSearchRow[]): AdminSearchHit[] {
  return rankMatches(query, senders, (s) => ({
    title: s.nickname,
    extra: `${s.fromEmail ?? ''} ${s.fromName ?? ''} ${s.phoneNumber ?? ''}`,
  })).map((s) => ({
    id: `sender-${s.id}`,
    title: s.nickname,
    meta: s.method === 'SMS' ? s.phoneNumber : s.fromEmail,
    href: `/admin/senders/${encodeURIComponent(s.id)}`,
  }))
}
